import React from 'react';
import { View, ActivityIndicator, ScrollView, StyleSheet } from 'react-native';
import { Divider } from '@rneui/themed';
import { useTranslation } from 'react-i18next';

import MenuItemList from 'features/menu/components/MenuItemList';
import { useMenuData } from '../hooks/useMenuData';
import { ScreenSizeContext } from 'context/ScreenSizeContext';
import { useLanguage } from 'context/LanguageContext';
import { type MenuProps } from 'types/ScreenTypes';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 24,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const MenuScreen: React.FC<MenuProps> = () => {
  const { tableList, menuMap } = useMenuData();
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const dimensions = React.useContext(ScreenSizeContext);

  const hasData =
    Object.keys(tableList).length !== 0 && Object.keys(menuMap).length !== 0;

  if (!hasData) {
    return (
      <View style={styles.container}>
        <ActivityIndicator />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ScrollView
        style={{
          width: dimensions.window.width > 600 ? '50%' : '100%',
          alignContent: 'center',
        }}
      >
        <MenuItemList tableList={tableList} key="table" title={t('table')} />
        <Divider />
        {Object.entries(menuMap).map(([key, item]) => (
          <MenuItemList
            key={key}
            title={item.name[currentLanguage]}
            tableList={item?.menu_list}
          />
        ))}
      </ScrollView>
    </View>
  );
};

export default MenuScreen;
